import pl from './pl.json';
import eng from './eng.json';

export default {
	pl,
	eng
};
